export enum LocalStorageDataEnum {
  AVATAR_USER_CONFIG_LIST = 'avatar-user-config-list',
  BOARD_BUILDER = 'board-builder-configuration',
  BOARD_BUILDER_SORTING_KEY = 'board-sorting-state-',
  BOARD_SCHEDULE_CELL = 'schedule-cell',
  BOARDS_VIEW_MODE = 'boards-view-mode',
  SERVICE_VIEW_MODE = 'service-view-mode',
  TURNOVER_VIEW_MODE = 'turnover-view-mode',
  TURNOVER_TYPE_VIEW = 'turnover-type-view',
  CALENDAR = 'calendar-configuration',
  KANBAN_ACTIVE_SECTIONS = 'kanban-active-sections',
  SETTINGS_TURNOVER_ELAPSED_DAYS_TOGGLE = 'settings-turnover-elapsed-days-toggle',
  SETTINGS_TURNOVER_STEP_ASSIGNEES_TOGGLE = 'settings-turnover-step-assignees-toggle',
  SETTINGS_TURNOVER_STEP_NOTIFICATIONS_TOGGLE = 'settings-turnover-step-notifications-toggle',
  SETTINGS_CUSTOM_FIELDS_TOGGLE = 'settings-custom-fields-toggle',
  SETTINGS_WORKFLOW_STEPS_TOGGLE = 'settings-workflow-steps-toggle',
  SETTINGS_COLLECTIONS = 'settings-collections',
  SETTINGS_COLLECTIONS_ACCESS = 'settings-collections-access',
  SETTINGS_COLLECTIONS_SET_PROPERTIES = 'settings-collections-set-properties',
  SETTINGS_COLLECTIONS_AVAILABLE_PROPERTIES = 'settings-collections-available-properties',
  CACHE_KEYS = 'cache-keys-{0}',
  //INSPECTION
  INSPECTION_LIST_SORT_ACTIVE = 'inspection-list-sort-active',
  INSPECTION_LIST_SORT_DIRECTION = 'inspection-list-sort-direction',
  INSPECTION_LIST_MODE = 'inspection-list-mode',
  INSPECTION_VIEW_MODE = 'inspection-view-mode',
  INSPECTION_LIST_USER_FILTER = 'inspection-list-user-filter-updated',
  INSPECTION_LIST_RESIDENT_FILTER = 'inspection-list-resident-filter-updated',
  INSPECTION_LIST_IN_REVIEW_FILTER = 'inspection-list-in-review-filter-updated',
  INSPECTION_LIST_DYNAMIC_FILTER = 'inspection-list-dynamic-filter-updated',
  INSPECTION_LIST_REPEATING_FILTER = 'inspection-list-repeating-filter-updated',
  INSPECTION_LIST_REPEATING_INSTANCES_SORT_ACTIVE = 'inspection-list-repeating-instances-sort-active',
  INSPECTION_LIST_REPEATING_INSTANCES_SORT_DIRECTION = 'inspection-list-repeating-instances-sort-direction',
  INSPECTION_LIST_BULK_FILTER = 'inspection-list-bulk-filter-updated',
  INSPECTION_LIST_BULK_SORT_ACTIVE = 'inspection-list-bulk-sort-active',
  INSPECTION_LIST_BULK_SORT_DIRECTION = 'inspection-list-bulk-sort-direction',
  INSPECTION_SECTION_STATES = 'inspection-section-states',
  INSPECTION_TEMPLATES_USER = 'inspection-templates-user',
  INSPECTION_TEMPLATES_CATEGORIES = 'inspection-templates-categories',
  INSPECTION_TEMPLATES_AVAILABLE = 'inspection-templates-available',
  INSPECTION_SUMMARY_STANDARD_SETTINGS_ID = 'inspection-summary-standard-settings-id',
  INSPECTION_SUMMARY_RESIDENT_SETTINGS_ID = 'inspection-summary-resident-settings-id',
  INSPECTION_FILTER_STANDARD_SETTINGS_ID = 'inspection-filter-standard-settings-id',
  INSPECTION_FILTER_RESIDENT_SETTINGS_ID = 'inspection-filter-resident-settings-id',
  //SERVICE
  SERVICE_LIST_FILTER = 'service-list-filter',
  SERVICE_LIST_SORT_ACTIVE = 'service-list-sort-active',
  SERVICE_LIST_SORT_DIRECTION = 'service-list-sort-direction',
  SERVICE_LIST_TICKETS_TOGGLE = 'service-list-tickets-toggle',
  SERVICE_LIST_FILTER_SETTINGS_ID = 'service-list-filter-settings-id',
  SERVICE_BULK_FILTER_SETTINGS_ID = 'service-bulk-filter-settings-id',
  SERVICE_REPEATING_FILTER_SETTINGS_ID = 'service-repeating-filter-settings-id',
  SERVICE_SUMMARY_SETTINGS_ID = 'service-summary-settings-id',
  USER_SUMMARY_SETTINGS_ID = 'user-summary-settings-id',
  BOARDS_SUMMARY_SETTINGS_ID = 'boards-summary-settings-id',

  SPARE_PARTS_ITEMS_TOGGLE = 'SPARE_PARTS_ITEMS_TOGGLE',
  SPARE_PARTS_ITEM_GROUPS_TOGGLE = 'SPARE_PARTS_ITEM_GROUPS_TOGGLE',
  SPARE_PARTS_SORT = 'SPARE_PARTS_SORT',
  SPARE_PARTS_VIEW_MODE = 'SPARE_PARTS_VIEW_MODE',
  SPARE_PARTS_FILTERS = 'SPARE_PARTS_FILTERS',

  InspectionFilterOffsetKey = '[inspections]_filter_offset',
  CollectionPropertiesFilterOffsetKey = '[collection-properties]_filter_offset',
  TurnoverFilterOffsetKey = '[turnover_list]_filter_offset',
  ReportRocFilterOffsetKey = '[report_roc]_filter_offset',
  ReportRentRollFilterOffsetKey = '[report_rent-roll]_filter_offset',
  BoardBuilderOffset = '[board_builder]_filter_offset',
  BoardBuilderResize = '[board_builder]_resize;id=',
  SERVICE_CANNED_ANSWERS_TOGGLE = 'service-canned-answers-toggle',
  INSTRUCTIONS_DISMISSED = 'instructions-dismissed',
  UNSAVED_DATA = 'resident-inspection-unsaved-data',

  // report tables
  ReportTimeTableFilterState = '[reports]_time',

  //TEMPLATE MANAGER
  TEMPLATE_MANAGER_ACTIVE_TAB = 'template-manager-active-tab',

  //SETTINGS
  SETTINGS_MAPPING_STATUSES_TOGGLE = 'SETTINGS_MAPPING_STATUSES_TOGGLE',
  SETTINGS_MAPPING_CATEGORIES_TOGGLE = 'SETTINGS_MAPPING_CATEGORIES_TOGGLE',
  SETTINGS_MAPPING_USERS_TOGGLE = 'SETTINGS_MAPPING_USERS_TOGGLE',
  SETTINGS_MAPPING_PRIORITIES_TOGGLE = 'SETTINGS_MAPPING_PRIORITIES_TOGGLE',
  SETTINGS_MAPPING_SYNC_OPTIONS_TOGGLE = 'SETTINGS_MAPPING_SYNC_OPTIONS_TOGGLE',
  SETTINGS_MAPPING_ORIGINS_TOGGLE = 'SETTINGS_MAPPING_ORIGINS_TOGGLE',
  SETTINGS_MAPPING_FAILOVER_IMPORT_TOGGLE = 'SETTINGS_MAPPING_FAILOVER_IMPORT_TOGGLE',
  SETTINGS_MAPPING_FAILOVER_EXPORT_TOGGLE = 'SETTINGS_MAPPING_FAILOVER_EXPORT_TOGGLE',

  SETTINGS_PROPERTY_MODEL_CUSTOM_FIELDS_SORT = 'SETTINGS_PROPERTY_MODEL_CUSTOM_FIELDS_SORT',

  SETTINGS_PORTFOLIOS = 'SETTINGS_PORTFOLIOS',
  SETTINGS_PROPERTIES = 'SETTINGS_PROPERTIES',

  // TURNOVER ARCHIVE
  TURNOVER_ARCHIVE_LIST_SORT_ACTIVE = 'turnover-archive-list-sort-active',
  TURNOVER_ARCHIVE_LIST_SORT_DIRECTION = 'turnover-archive-list-sort-direction',
  TURNOVER_LIST_SUMMARY_CLIENT_PART_FILTERS = 'turnover-list-summary-client-filters',
  TURNOVER_LIST_SUMMARY_SERVER_PART_FILTERS = 'turnover-list-summary-server-filters',

  BOARD_FILTER = 'board-filter',

  NOTIFICATION_PERSONAL_lIST_TOGGLE = 'notification-personal-list-toggle',
  NOTIFICATION_USER_lIST_TOGGLE = 'notification-user-list-toggle',

  //SUMMARY
  INSPECTIONS_SUMMARY_FILTERS = 'inspections-summary-filters',
  BOARDS_SUMMARY_BOARD_TYPE = 'boards-summary-board-type',
  BOARDS_SUMMARY_BOARD_ID = 'boards-summary-board-id',
  SERVICE_SUMMARY_TICKET_TYPE = 'service-summary-ticket-type',
  TURNOVER_SUMMARY_QUERY_TYPE = 'turnover-summary-query-type',
  TURNOVER_SUMMARY_COLUMNS = 'turnover-summary-columns',

  //UPPD
  PREV_SWITCH_STATUS = 'prev-switch-status',
  PREV_PORTFOLIO_CONTROL_VALUE = 'prev-portfolio-control-value',
  PREV_PORTFOLIO_PROPERTIES_CONTROL_VALUE = 'prev-portfolio-properties-control-value',
  PREV_COLLECTION_CONTROL_VALUE = 'prev-collection-control-value',
  IS_ALL_COLLECTIONS_SELECTED = 'is-all-collections-selected',
  PREV_COLLECTION_PROPERTIES_CONTROL_VALUE = 'prev-collection-properties-control-value',

  // DILIGENCE
  DILIGENCE_LIST_SORT_ACTIVE = 'diligence-list-sort-active',
  DILIGENCE_LIST_SORT_DIRECTION = 'diligence-list-sort-direction',
  DILIGENCE_LIST_FILTER = 'diligence-list-filter',
  DILIGENCE_UNITS_SORT_ACTIVE = 'diligence-units-sort-active',
  DILIGENCE_UNITS_SORT_DIRECTION = 'diligence-units-sort-direction',
  DILIGENCE_INSPECTIONS_SORT_ACTIVE = 'diligence-inspections-sort-active',
  DILIGENCE_INSPECTIONS_SORT_DIRECTION = 'diligence-inspections-sort-direction',
  DILIGENCE_DETAILS_UNITS_EXPANDED = 'diligence-details-units-expanded',
  DILIGENCE_DETAILS_INSPECTIONS_EXPANDED = 'diligence-details-inspections-expanded',

  // USER REPORTS
  USER_REPORTS_SORT_ACTIVE = 'user-reports-sort-active',
  USER_REPORTS_SORT_DIRECTION = 'user-reports-sort-direction',
  USER_REPORTS_FILTER = 'user-reports-filter',

  // DASHBOARD
  DASHBOARD_USER_ID = 'dashboard-user-id',
  DASHBOARD_REPORT_ID = 'dashboard-report-id',

  // BB
  BB_LIST_SORT_ACTIVE = 'bb-list-sort-active',
  BB_LIST_SORT_DIRECTION = 'bb-list-sort-direction',
  PROJECT_LIST_SECTIONS = 'projects-active-sections',

  // projects
  PROJECTS_LIST_FILTER = 'projects-list-filter',
  PROJECTS_LIST_SORTING = 'projects-list-sorting',

  // purchase orders
  PURCHASE_ORDERS_LIST_FILTER_SETTINGS_ID = 'purchase-orders-list-filter-settings-id',

  RENT_ROLL_SORT_ACTIVE = 'rent-roll-sort-active',
  RENT_ROLL_SORT_DIRECTION = 'rent-roll-sort-direction',
  RENT_ROLL_FILTER = 'rent-roll-filter',
  RENTABLE_ITEMS_FILTER = 'rentable-items-filter',
}
